import { catalogRoutes } from "./catalog.routes";
import { competitorsRoutes } from "./competitors.routes";
import { forecastingRoutes } from "./forecasting.routes";
import { homeRoutes } from "./home.routes";
import { notFoundRoutes } from "./notFound.routes";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

/**
 * Children of the `/tools` parent: relative paths, names under `ToolsRoutes`.
 * The parent itself (layout, gate, `meta.workspace`) lives in `app/router/modules.ts`.
 */
export const toolsRoutes: AppRouteRecordRaw[] = [
  ...homeRoutes,
  ...catalogRoutes,
  ...competitorsRoutes,
  ...forecastingRoutes,
  ...notFoundRoutes,
];
